import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Form as FormComponent,
} from 'reactstrap';
import { PatientsTableComponent } from '../../../Tables';
import { PatientItem } from '../../../Tables/Patients';
import { Form, Field } from 'react-final-form';
import { Filter } from 'react-table';
export type SearchBarForm = {
  given?: string;
  family?: string;
  identifier?: string;
};
const SearchBar = ({
  onSubmit,
}: {
  onSubmit: (values: SearchBarForm) => void;
}) => (
  <Form<SearchBarForm> onSubmit={onSubmit}>
    {({ handleSubmit }) => (
      <FormComponent onSubmit={handleSubmit}>
        <InputGroup>
          <InputGroupAddon addonType="prepend">Search</InputGroupAddon>
          <Field<string> name="given">
            {({ input, meta, ...rest }) => (
              <Input
                {...input}
                {...rest}
                type="text"
                placeholder="First Name"
              />
            )}
          </Field>
          <Field<string> name="family">
            {({ input, meta, ...rest }) => (
              <Input {...input} {...rest} type="text" placeholder="Last Name" />
            )}
          </Field>
          <Field<string> name="identifier">
            {({ input, meta, ...rest }) => (
              <Input {...input} {...rest} type="text" placeholder="MRN" />
            )}
          </Field>
          <InputGroupAddon addonType="append">
            <Button type="submit">Go</Button>
          </InputGroupAddon>
        </InputGroup>
      </FormComponent>
    )}
  </Form>
);

const PatientTable = (props: {
  patients: PatientItem[];
  organizationId?: string;
  loading?: boolean;
  last?: boolean;
  page: number;
  filtered: Filter[];
  hideInactive: boolean;
  onSearchBarSubmit: (values: SearchBarForm) => void;
  setHideInactive: (hideInactive: boolean) => void;
  onFetchData: (state: any, instance: any) => void;
  onPageChange: (page: number) => void;
}) => (
  <Card>
    <CardBody>
      <Row>
        <Col>
          <CardTitle tag="h3">Patients</CardTitle>
        </Col>
        <Col>
          <SearchBar onSubmit={props.onSearchBarSubmit} />
        </Col>
      </Row>
      <PatientsTableComponent
        patients={props.patients}
        loading={props.loading}
        last={props.last}
        filtered={props.filtered}
        page={props.page}
        onPageChange={props.onPageChange}
        organizationId={props.organizationId}
        onFetchData={props.onFetchData}></PatientsTableComponent>
    </CardBody>
  </Card>
);

export default PatientTable;
